/** Normalize audit id from URL params, API payloads, or form values (numeric or string). */
export function normalizeAuditId(id) {
	if (id == null || id === "") return null;
	const s = String(id).trim();
	if (s === "") return null;
	const n = Number(s);
	return Number.isFinite(n) && String(n) === s ? n : s;
}

export function auditIdsMatch(a, b) {
	return normalizeAuditId(a) === normalizeAuditId(b);
}

export function parseAuditIdParam(param) {
	if (param == null) return null;
	return normalizeAuditId(String(param).trim());
}

export function isValidAuditId(auditId) {
	return normalizeAuditId(auditId) != null;
}

/** Value to send in MS1 API bodies — number when numeric, string otherwise. */
export function formatAuditIdForApi(auditId) {
	const normalized = normalizeAuditId(auditId);
	if (normalized == null) return null;
	return typeof normalized === "number" ? normalized : String(normalized);
}
